interface HealthScoreGaugeProps {
  score: number
}

export function HealthScoreGauge({ score }: HealthScoreGaugeProps) {
  const normalizedScore = Math.min(Math.max(score, 0), 100)
  const radius = 80
  const stroke = 12
  const normalizedRadius = radius - stroke * 2
  const circumference = normalizedRadius * 2 * Math.PI
  const strokeDashoffset = circumference - (normalizedScore / 100) * (circumference / 2)

  const getColor = (val: number) => {
    if (val >= 90) return '#10b981'
    if (val >= 75) return '#3b82f6'
    if (val >= 50) return '#f59e0b'
    return '#ef4444'
  }

  return (
    <div className="relative flex items-center justify-center overflow-hidden h-[130px] w-full">
      <div className="relative flex items-center justify-center">
        <svg height={radius * 1.5} width={radius * 2} className="transform -rotate-180" viewBox={`0 0 ${radius * 2} ${radius * 1.5}`}>
          <circle stroke="#1e293b" fill="transparent" strokeWidth={stroke} strokeDasharray={`${circumference} ${circumference}`} style={{ strokeDashoffset: circumference / 2 }} strokeLinecap="round" r={normalizedRadius} cx={radius} cy={radius} />
          <circle stroke={getColor(normalizedScore)} fill="transparent" strokeWidth={stroke} strokeDasharray={`${circumference} ${circumference}`} strokeDashoffset={strokeDashoffset} strokeLinecap="round" r={normalizedRadius} cx={radius} cy={radius} className="drop-shadow-[0_0_8px_rgba(59,130,246,0.3)] transition-all duration-1000" />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center pt-8">
          <span className="text-4xl font-black font-mono text-white leading-none">{normalizedScore}%</span>
          <span className="text-[10px] text-slate-500 uppercase tracking-widest font-bold mt-1">Health Score</span>
        </div>
      </div>
    </div>
  )
}
